import el from "@cypherpotato/el";
import { api } from "../api";
import { Icon } from "../components/icon";
import { Image } from "../components/image";
import { loadRerankers } from "../rerankers";
import { displayFinder } from "../ui/alert";
import { Paragraph } from "../components/text";
import { TagBadge } from "../components/badge";

function pickModel({ placeholder, options, selectedModel }) {
    return new Promise(resolve => {
        displayFinder({
            placeholder,
            options,
            selectedId: selectedModel,
            onSelect: resolve
        });
    });
}

export async function PickRerankerModel({ selectedModel, filter = () => true } = {}) {
    const rerankers = await loadRerankers();
    const options = rerankers.filter(filter).map(reranker => ({
        group: "Available models",
        title: reranker.name,
        description: el("div",
            el("div", reranker.description),
            el("div", TagBadge(reranker.pricingDescription)),
        ),
        icon: Icon("sort-desc"),
        id: reranker.name
    }));

    return pickModel({
        placeholder: "Search reranker models...",
        options,
        selectedModel
    });
}

export async function PickImageGenModel({ selectedModel } = {}) {
    const response = await api.getJson("/api/v1/information/image-models.json");
    const options = (response?.data || []).map(model => ({
        group: "Available models",
        title: model.name,
        icon: Image(`/assets/imggenmodels/${model.name.replace(/^@[^/]+\//, "")}.webp`, {
            alt: `${model.name} preview`
        }),
        id: model.name
    }));

    return pickModel({
        placeholder: "Search image generation models...",
        options,
        selectedModel
    });
}